export const CONTACT = {
  address: "Rua da Quinta, lote 109, RC-B Urb. St. Clara",
  city: "Leiria, Portugal",
  mobile: "914 562 066",
  phone: "244 025 959",
  email: "admi@innpact.com.pt",
  facebook: "https://www.facebook.com/innpact.consultoria.cabeleireiros/",
  instagram: "https://www.instagram.com/inn.pact/",
  whatsapp: "https://wa.me/351914562066",
  hours: "Segunda a Sábado · 9h00 – 13h00 / 14h30 – 20h00",
};

export const SERVICES = [
  {
    id: "hairstyling",
    title: "Hairstyling",
    description:
      "Uma primeira consulta gratuita para vos conhecermos. Olhamos para o seu rosto, para o tipo de cabelo e para o que gosta, e a partir daí definimos o que faz sentido para si.",
    image:
      "https://images.unsplash.com/photo-1734111719430-fe4a3973f8af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBmZW1hbGUlMjBoYWlyJTIwc3R5bGlzdHxlbnwwfHx8fDE3ODM0NTU0MTZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "pack-noivas",
    title: "Pack Noivas",
    description:
      "Um look pensado consigo, para si e para o seu dia. Cabelo, maquilhagem e assessoria para a noiva e para a família, sem stress e sem improvisos.",
    image: "/images/services/pack-noivas.webp",
  },
  {
    id: "consultoria",
    title: "Consultoria de Imagem",
    description:
      "Pessoal: todos os aspetos em si contam. Empresarial: só tem uma oportunidade para criar a primeira impressão. Lojas: apoiamos as lojas a fidelizar os seus clientes.",
    image: "/images/services/consultoria.webp",
  },
  {
    id: "man-style",
    title: "Man Style",
    description:
      "Consultoria de imagem masculina, prática e direta. O guarda-roupa masculino tem maior longevidade, por isso construímos uma imagem sólida que dura.",
    image: "/images/services/man-style.webp",
  },
  {
    id: "workshops",
    title: "Workshops & Formação",
    description:
      "Formação prática, em grupos pequenos, sobre o que anda a mudar na moda e na imagem. Traz-se o portátil, sai-se com ideias novas para aplicar.",
    image: "/images/services/workshops.webp",
  },
];

export const BRANDS = [
  { name: "BlondMe", logo: "/brands/blondme.png" },
  { name: "Nioxin", logo: "/brands/nioxin.png" },
  { name: "American Crew", logo: "/brands/american-crew.png" },
  { name: "Sebastian Professional", logo: "/brands/sebastian.png" },
  { name: "Revlon Professional", logo: "/brands/revlon.png" },
];

export const TEAM = [
  {
    name: "Severina Gomes",
    role: "Founder & CEO & Style Coach",
    image: "/images/team/severina.webp",
    bio: "Fundadora da INN.PACT e Country Winner Portugal no Revlon Style Masters (Barcelona 2018). Continua a formar-se todos os anos para trazer o que há de melhor ao salão.",
  },
  {
    name: "Nicole Babonea",
    role: "Hair Style",
    image: "/images/team/nicole.webp",
    bio: "Especialista em cortes e cor. Trabalha com calma, ouve antes de mexer e gosta de perceber o cabelo de cada pessoa antes de propor mudanças.",
  },
];

export const TESTIMONIALS = [
  {
    name: "João Nunes Santos",
    role: "Cliente",
    quote: "Profissionais de topo. Conceito inovador. Sempre um passo à frente. Sucesso.",
  },
  {
    name: "Isabel Bastos",
    role: "Cliente",
    quote:
      "Foi uma experiência única, aprendi muito, só tenho é que agradecer à equipa de Inn.Pact, têm sido sempre uns excelentes profissionais. Muito obrigada.",
  },
  {
    name: "Claudia Crespo",
    role: "Cliente",
    quote: "Não troco a Inn.Pact por nada!! Excelentes profissionais, simpatia e excelência.",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Diagnóstico",
    text: "Análise geral da sua imagem, biótipo e estado de saúde do cabelo. Aconselhamento personalizado e gratuito.",
  },
  {
    step: "02",
    title: "Consulta de Visagismo",
    text: "Estudo do rosto, personalidade e objetivos para definir a direção certa para a sua imagem.",
  },
  {
    step: "03",
    title: "Transformação",
    text: "Execução com produtos e técnicas profissionais, alinhada à sua identidade e estilo de vida.",
  },
  {
    step: "04",
    title: "Acompanhamento",
    text: "Orientação contínua para manter uma imagem cuidada, harmoniosa e coerente ao longo do tempo.",
  },
];

export const NAV_LINKS = [
  { label: "Início", href: "#inicio" },
  { label: "Serviços", href: "#servicos" },
  { label: "Espaço", href: "#espaco" },
  { label: "Equipa", href: "#equipa" },
  { label: "Testemunhos", href: "#testemunhos" },
  { label: "Contactos", href: "/contactos" },
];

export const ESPACO = {
  hero: "/espaco/espaco_entrada.webp",
  intro:
    "No coração de Leiria, o nosso salão foi montado para o receber como se fosse a nossa casa. Boas máquinas, marcas em que confiamos, luz certa e uma cadeira à sua espera. É o sítio onde se senta, respira fundo e sai a sentir-se melhor.",
  gallery: [
    { src: "/espaco/espaco_entrada.webp", caption: "Entrada da INN.PACT Clínica de Imagem em Leiria com poster Revlon Style Masters" },
    { src: "/espaco/espaco_salao.webp", caption: "Sala de hairstyling profissional com marcas Revlon e American Crew na INN.PACT Leiria" },
    { src: "/espaco/espaco_greenwall.webp", caption: "Parede verde INN.PACT com logótipo, espaço de consultoria de imagem em Leiria" },
    { src: "/espaco/espaco_cadeiras.webp", caption: "Sala de espera INN.PACT em Leiria, ambiente acolhedor e moderno" },
    { src: "/espaco/espaco_revlon.webp", caption: "Prémio Revlon Style Masters Barcelona 2018, INN.PACT Country Winner Portugal" },
  ],
  features: [
    "Sala de hairstyling equipada",
    "Espaço privado para consultoria",
    "Marcas profissionais em que confiamos",
    "No centro de Leiria, fácil de chegar",
  ],
};

export const HERO_IMAGE = "/images/hero.webp";

export const STORY_IMAGE = "/images/story/essencia.webp";
